import { $, el } from '../state/store.js';
import { analyticsNeedsChoice, setAnalyticsConsent } from '../services/analytics.js';
import { PRIVACY_URL } from '../services/limits.js';

/* THE ANALYTICS CONSENT BAR.

   A bar, not a wall. Product analytics is worth asking for and is not worth
   standing in front of the app for — nothing here is gated on the answer, so
   blocking the page to collect one would be pretending otherwise.

   What it says is what is collected, not who processes it. "PostHog" means
   nothing to almost anyone and would spend the one sentence available on a
   vendor name instead of on the two facts that actually inform the choice:
   that it is usage events, and that it is never the work. The privacy policy
   carries the processor, the region and the retention, which is where the law
   expects that detail and where it can be kept accurate without a redeploy.

   "Never what you make" is the line that earns its place. This is a design
   tool; the instinctive worry is that unreleased client work is being
   uploaded somewhere. It is not — track() sends a short, deliberate list of
   product events (an export, a template applied, a purchase) and no document
   ever goes near it.

   Both answers weigh the same. A decline dressed as the quiet option is not a
   free choice, and a consent that was not freely given is not consent. */

const BAR_ID = 'consentBar';

export function initConsent() {
  if (!analyticsNeedsChoice()) return;      // answered already, or nothing to ask about
  if ($('#' + BAR_ID)) return;

  const bar = el('div', 'consent');
  bar.id = BAR_ID;
  bar.setAttribute('role', 'dialog');
  bar.setAttribute('aria-label', 'Analytics');

  const txt = el('p', 'consent__txt',
    'Help us improve Illusio 3D? We’d like to see which features get used — '
    + 'exports run, templates applied. Never what you make. ');
  /* The detail this bar deliberately leaves out. The comment above argues that
     naming a vendor here would spend the one sentence available on something
     that informs nobody — but the processor, the region and the retention have
     to be somewhere reachable, and until now that was a promise with nowhere
     to go. */
  const more = el('a', 'consent__link', 'Privacy policy');
  more.href = PRIVACY_URL;
  more.target = '_blank';
  more.rel = 'noopener noreferrer';
  txt.appendChild(more);
  bar.appendChild(txt);

  const row = el('div', 'consent__btns');
  const answer = (label, cls, v) => {
    const b = el('button', 'btn btn--sm ' + cls, label);
    b.onclick = () => { setAnalyticsConsent(v); bar.remove(); };
    row.appendChild(b);
  };
  /* Decline FIRST in the DOM, and the same size, in the same place, one tap
     away — which is what "freely given" actually requires. What it does not
     require is that the two look identical: a filled accept beside an outlined
     decline is the ordinary pattern, and the objection regulators raise is to
     refusing being HARDER, not to accepting being prettier.

     So the line this must never cross is a change to that first button —
     shrinking it, greying it toward looking disabled, turning it into a text
     link, or moving it behind a "manage preferences" step. Any of those turns
     a legitimate emphasis into the dark pattern the emphasis is adjacent to. */
  answer('No thanks', 'btn--gh', 'no');
  answer('Allow', 'btn--pri', 'yes');
  bar.appendChild(row);

  document.body.appendChild(bar);
}
